module.exports = __webpack_public_path__ + "static/media/gls_leg_l.7717029a.png";